import { PASSES_LANDING } from "@/settings/constant";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDialogStore } from "src/store/useDialogStore";
/** 가드 다이얼로그는 한 번에 하나만 뜬다 */ const GUARD_DIALOG_ID = "subscriptionEntryGuard";
/**
 * plan 응답으로 진입 차단 여부와 문구를 판정한다.
 *
 * 차단할 필요가 없으면 null. 조회 전(plan 없음) 판정은 호출부가 막는다 —
 * 여기서 undefined를 받아 '차단 아님'으로 답하면 로딩 중에 화면이 열려버린다.
 *
 * 우선순위는 alreadySubscribed 가 먼저다. 판매 종료와 동시에 걸릴 수 있는데,
 * 이미 구독 중이라는 사실이 더 구체적이고 다음 행동(연간권)까지 안내할 수 있다.
 */ export const getGuardDialog = (plan)=>{
    if (plan.alreadySubscribed) {
        return {
            title: "이미 구독 중인 이용권이에요.",
            description: "자료가 더 필요하다면 연간권을 이용해보세요."
        };
    }
    if (plan.purchasability.purchasable) return null;
    if (plan.purchasability.reason === "sales_ended") {
        return {
            title: "판매가 종료된 상품이에요."
        };
    }
    var _plan_purchasability_message;
    // job·age·purchase_history. 사유별 문구 대신 어드민이 입력한 message를 그대로 노출한다
    return {
        title: "특정 회원만 구매할 수 있어요.",
        description: (_plan_purchasability_message = plan.purchasability.message) !== null && _plan_purchasability_message !== void 0 ? _plan_purchasability_message : undefined
    };
};
/**
 * 월구독 결제 페이지 진입 가드
 *
 * 형제 가드(useCheckPurchaseOrder·useUpgradeOrderGuard)와 같은 자리·같은 방식이지만
 * 그쪽은 판정 근거가 별도 API(useCheckOrder)와 pass·package 응답 필드라 재사용할 수 없다.
 * 구독은 plan 응답 하나에 판정이 다 들어 있다.
 *
 * 이 가드가 없으면 이미 구독 중인 유저가 카드 등록까지 마치고 가입 요청까지 완주한다.
 * 빌링키만 헛으로 발급되고, 중복 청구 차단은 BE 검증에만 의존하게 된다.
 */ const useSubscriptionEntryGuard = (param)=>{
    let { enabled , plan  } = param;
    const { open  } = useDialogStore();
    const router = useRouter();
    useEffect(()=>{
        if (!enabled || !plan) return;
        const dialog = getGuardDialog(plan);
        if (!dialog) return;
        open({
            id: GUARD_DIALOG_ID,
            type: "confirm",
            props: {
                severity: "error",
                ...dialog,
                confirmText: "돌아가기",
                // 닫고 결제를 시도하는 우회를 막는다. DialogProvider가 onOpenChange를 넘기지 않아
                // 지금도 ESC·배경 클릭으로는 닫히지 않지만, 의도를 코드에 남긴다.
                contentProps: {
                    onEscapeKeyDown: (event)=>event.preventDefault(),
                    onPointerDownOutside: (event)=>event.preventDefault(),
                    onInteractOutside: (event)=>event.preventDefault()
                },
                onConfirm: ()=>{
                    // 링크로 직접 열어 히스토리가 없으면 back()이 아무 일도 하지 않는다
                    if (window.history.length > 1) {
                        router.back();
                        return;
                    }
                    router.replace(PASSES_LANDING);
                }
            }
        });
    }, [
        enabled,
        plan,
        open,
        router
    ]);
};
export default useSubscriptionEntryGuard;
